<template>
    <div>
        <b-row>
            <b-col md="6" class="my-1">
                <h3 class="text-themecolor">{{$t('klantrelaties.klantrelatie')}}</h3>
            </b-col>
            <b-col md="6" class="my-1">
                <div class="pull-right">
                    <b-button size="sm" @click.stop="goTo('update')" variant="themecolor" class="mr-1">
                        <i class="fa fa-edit" aria-hidden="true"></i> {{$t('buttons.bewerken')}}
                    </b-button>
                    <delete title="Klantrelatie" :id="customerRelation.id" namespace="core" resource="customer-relations" />
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="4" xlg="3" md="4">
                <div class="card">
                    <div class="card-body">
                        <center class="m-t-30">
                            <h4 class="card-title m-t-10">{{customerRelation.tag}} {{customerRelation.name}}</h4>
                            <h6 class="card-subtitle" v-if="customerRelation.address">
                                {{customerRelation.address.street}} {{customerRelation.address.zipCode}} {{customerRelation.address.city}}
                            </h6>
                        </center>
                    </div>
                    <div>
                        <hr> 
                    </div>
                    <div class="card-body">
                        <small class="text-muted">Website</small>
                            <h6>
                                <a :href="customerRelation.websiteUrl" target="_blank">{{customerRelation.websiteUrl}}</a>
                            </h6>  
                        <div v-if="customerRelation.emailAddress">                        
                            <small class="text-muted">{{$t('datatables.emailadres')}}</small>
                            <h6>
                                <a :href="'mailto:'+customerRelation.emailAddress.address">{{customerRelation.emailAddress.address}}</a>
                                
                            </h6>                          
                        </div>
                    </div>
                </div>
            </b-col>
            
            <b-col lg="8" xlg="9" md="8">
                <div class="card">
                    <ul class="nav nav-tabs profile-tab" role="tablist">
                        <li class="nav-item">
                            <router-link :to="{ name: 'customer-relations:detail:contact-persons' }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                    {{$t('klantrelaties.contactpersonen')}}
                            </router-link>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" role="tabpanel">
                            <!-- Tabs, lazy loading -->
                            <router-view />
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.terugnaaroverzicht')}}</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'customer-relations-detail',
    computed: {
        ...mapGetters('core',['customerRelation']),
    },
    methods: {
        ...mapActions('core',['find','delete']),
        deleteItem(id) 
        {
            var vm = this;
            vm.delete({
                resource: 'customer-relations',
                path: 'customer-relations',
                id: id
            })
            .then(() => {
                vm.$swal(this.$i18n.t('delete.succesvol'), `${this.$i18n.t('delete.de')} ${vm.title.toLowerCase()} ${this.$i18n.t('delete.isverwijderd')}`, this.$i18n.t('delete.succes'));   
                vm.goTo('index');
            })
            .catch(() => {
                vm.$swal(this.$i18n.t('delete.mislukt'), `${this.$i18n.t('delete.de')} ${vm.title.toLowerCase()} ${this.$i18n.t('delete.konnietwordenverwijderd')}`, this.$i18n.t('delete.error'));
            });
        },
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `customer-relations:${name}` });
        }
    },
    created() {
        var vm = this;
        vm.find({
            resource: 'customer-relations', 
            id: vm.$route.params.customerRelationId
        });
    }
}
</script>